/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import BasicLayout from "../components/BasicLayout";
import { CircularProgress } from "@mui/material";

function Cover() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleContinue = () => {
    if (email) {
      setIsSubmitted(false);
    } else {
      setIsSubmitted(true);
    }
  };

  return (
    <BasicLayout bgColor="info" image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          // borderRadius="lg"
          coloredShadow="success"
          // mx={2}
          // mt={-3}
          p={3}
          mb={1}
          textAlign="center"
          sx={{
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
          }}
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Forgot Password
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            You will receive an e-mail.
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox
            component="form"
            role="form"
            onSubmit={(e) => {
              e.preventDefault();
              handleContinue(); // same as your onClick
            }}
          >
            <MDBox mb={4}>
              <MDInput
                type="email"
                label={
                  <>
                    Email
                    <span style={{ color: "red" }}>*</span>
                  </>
                }
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                helperText={isSubmitted && !email ? "Email is required" : ""}
                FormHelperTextProps={{
                  sx: {
                    color: "red",
                    marginLeft: "0",
                  },
                }}
              />
            </MDBox>
            <MDBox mt={6} mb={1}>
              <MDButton
                type="submit"
                variant="gradient"
                color="info"
                fullWidth
                onClick={handleContinue}
                disabled={isLoading}
              >
                {isLoading ? <CircularProgress size={24} color="light" /> : "Get Reset Link"}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Cover;
